"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CUSTOM_GATEWAY_STATUS = void 0;
exports.CUSTOM_GATEWAY_STATUS = {
    RECEIVED: 1,
    IN_PRODUCTION: 4,
    DISPATCHED: 8,
    CANCELLED: 128,
    RECEIVED_BY_SUPPLIER: 513,
    RECEIVED_BY_SHIPPER: 516,
    ON_HOLD: 256
};
//# sourceMappingURL=customGatewayStatus.js.map